import React from 'react'
import styled from 'styled-components'

import sdkLogoImg from '@/assets/images/sdk_logo.gif'
import { mobile } from '@/utils/media-query'

import { SectionBlock } from './section'

const SDKLogo = styled.img`
  width: 400px;

  @media ${mobile.query} {
    width: 260px;
  }
`

const Blurb = styled.div`
  text-align: center;
  max-width: 800px;

  p {
    font-size: 20px;
    line-height: 30px;
    color: ${({ theme }) => theme.palette.giphyWhite};
    opacity: 0.85;
  }

  @media ${mobile.query} {
    width: 100%;
    height: 100%;

    p {
      font-size: 18px;
      line-height: 26px;
      opacity: 0.8;
    }
  }
`

export const SDKIntroBlock = () => {
  return (
    <SectionBlock>
      <SDKLogo src={sdkLogoImg} />
      <Blurb>
        <p>
          Whatever your needs, it’s never been easier to bring the full GIPHY experience to your
          audience. Built with developers and product designers in mind, our SDK is the solution for
          incorporating Clips, GIFs, stickers, and exclusive content like GIPHY Text and Emoji into
          your next app or website.
        </p>
      </Blurb>
    </SectionBlock>
  )
}
